import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm09 from "../data/form09.data";

type Props = {
  onSubmit?: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};

interface WorkPermitPeriod {
  period_date: string[];
  description: string;
  ref_date: string;
}

const Form09: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave09, setInputValueFormLeave09] = useState({
    information: {
      title_en: "",
      first_name_en: "",
      last_name_en: "",
      buddhist_name_en: "",
    },
    operational_data: {
      organization: "",
      country: "",
      position: "",
      level: "",
      since_date: "",
      work_permit_amonth: 1,
      time_work_permit: [],
      total_consecutive_period_year: 0,
      total_consecutive_period_month: 0,
    },
    current_contact_address: {
      temple_name: "",
      house_no: "",
      street: "",
      country: "",
      province: "",
      district: "",
      district_sub: "",
      village: "",
      postcode: "",
    },
    info_about_religious_continued: {
      organization_requesting_work: "",
      country: "",
      position: "",
      start_date: "",
      end_date: "",
    },
    reason: {
      reasons_necessity_continue: "",
      benefit_university_receive: "",
    },
  });
  const [inputPeriod, setInputPeriod] = useState<WorkPermitPeriod[]>([
    { period_date: [], description: "", ref_date: "" },
  ]);

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave09.information;
    const operational_data = {
      ...inputValueFormLeave09.operational_data,
      time_work_permit: inputPeriod,
    };
    const current_contact_address =
      inputValueFormLeave09.current_contact_address;
    const info_about_religious_continued =
      inputValueFormLeave09.info_about_religious_continued;
    const reason = inputValueFormLeave09.reason;

    setData({
      main: information,
      condition: condition,
      operational_data: operational_data,
      current_contact_address: current_contact_address,
      info_about_religious_continued: info_about_religious_continued,
      reason: reason,
    });
  }, [inputValueFormLeave09]);

  useEffect(() => {
    if (data) {
      setInputValueFormLeave09({
        information: data.condition ?? inputValueFormLeave09.information,
        operational_data:
          data.operational_data ?? inputValueFormLeave09.operational_data,
        current_contact_address:
          data.current_contact_address ??
          inputValueFormLeave09.current_contact_address,
        info_about_religious_continued:
          data.info_about_religious_continued ??
          inputValueFormLeave09.info_about_religious_continued,
        reason: data.reason ?? inputValueFormLeave09.reason,
      });
      setInputPeriod(data.operational_data.time_work_permit ?? []);
    }
  }, []);

  console.log("inputValueFormLeave09", inputValueFormLeave09);

  return (
    <div
    // onClick={() => {
    //   onSubmit("text");
    // }}
    >
      <FormComponent
        formGenerate={generateForm09}
        inputValue={inputValueFormLeave09}
        setInputValue={setInputValueFormLeave09}
        handleCheckValid={isValidateForm}
        isCanEdit={isCanEdit ?? true}
        permission={"admin"}
        setInputPeriod={setInputPeriod}
      />
    </div>
  );
};

export default Form09;
